// ** Logo
//import logo from '@src/assets/images/logo/logo.png'

import {applyooConfig} from "../../../applyoo/js/applyooConfig";
import {utils_ui} from "../../../applyoo/utils/utils_ui";

const SpinnerComponent = () => {
    //const baseFilesURL = "https://localhost:44331"
    const logo = `${utils_ui.getBaseFilesUrl()}/assets/static/logos/logo.svg`
  return (
    <div className='fallback-spinner vh-100'>
      <img className='fallback-logo' src={logo} alt='logo' />
      <div className='loading'>
        <div className='effect-1 effects'></div>
        <div className='effect-2 effects'></div>
        <div className='effect-3 effects'></div>
      </div>
    </div>
  )
}

export default SpinnerComponent
